import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import ParticipantDashboard from "./pages/ParticipantDashboard";
import TestRunner from "./pages/TestRunner";
import Results from "./pages/Results";
import BookOfActivities from "./pages/BookOfActivities";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={<ParticipantDashboard />} />
            <Route path="/test/:testId/:phase" element={<TestRunner />} />
            <Route path="/results" element={<Results />} />
            <Route path="/activities" element={<BookOfActivities />} />
            <Route path="/login" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
